import { FC } from 'react';

import { FAQList } from '../partials/FAQList';
import { InfoDialog } from './InfoDialog';

type Props = {
  open: boolean
  onClose: () => void
}

export const FAQDialog: FC<Props> = ({ open, onClose }) => {
  return (
    <InfoDialog id="faq-dialog" title="Frequently Asked Questions" open={open} onClose={onClose}>
      <FAQList />
    </InfoDialog>
  );
};
